import { QueryClient } from "@tanstack/react-query";

import { ApiError, ContractViolationError } from "@/lib/api/fetcher";

// Retrying cannot fix a client error or a contract mismatch; only a transient failure is retried.
const isRetryable = (error: unknown) =>
    !(error instanceof ContractViolationError) && !(error instanceof ApiError && error.status < 500);

export function createQueryClient(): QueryClient {
    return new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 1000,
                retry: (failureCount, error) => failureCount < 2 && isRetryable(error),
            },
        },
    });
}
